import { render } from "./PrevNext.vue?vue&type=template&id=f2568738&scoped=true"
import script from "./PrevNext.vue?vue&type=script&lang=js"
export * from "./PrevNext.vue?vue&type=script&lang=js"

import "./PrevNext.vue?vue&type=style&index=0&id=f2568738&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2568738"]])

export default __exports__